/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiShipmatchRule.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-shipmatch-rule";

export class AutogenModelEdiShipmatchRule<RowType extends ModelRow> extends Endpoint<RowType, RowEdiShipmatchRuleFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiShipmatchRule extends ModelRow<RowEdiShipmatchRuleFields> {
	constructor(values?: Partial<RowEdiShipmatchRuleFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiShipmatchRuleFields {
	company_id: string;
	criteria_id: string;
	deduct_code_id: string;
	edi_deduct_code_id: string;
	edi_disregard_text: string;
	edi_disregard_type: string;
	edi_field_name: string;
	edi_reference_qual: string;
	edi_remove_zeropad: string;
	edi_table_name: string;
	field_name: string;
	id: string;
	operator: string;
	profile_id: string;
	reference_qual: string;
	sequence: number;
	table_name: string;
}

